import * as React from 'react';
import type { SVGProps } from 'react';
const SvgChevronThin = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={12} height={12} fill="none" {...props}>
    <path fill="#343333" fillRule="evenodd" d="M0 3.668.668 3 6 8.332 11.332 3l.668.668-6 6z" clipRule="evenodd" />
  </svg>
);
export default SvgChevronThin;
